








































import { mapActions, mapGetters, mapState } from 'vuex';
import MiniSearch from '@/components/search/MiniSearch.vue';

export default {
  computed: {
    ...mapState([
      'enableSound',
    ]),
    ...mapGetters('auth', [
      'user',
    ]),
  },
  methods: {
    ...mapActions([
      'toggleSound',
    ]),
    ...mapActions('chrome', [
      'showStack',
    ]),
    changeSound() {
      this.toggleSound();
      this.enableSound
        && this.$sound.play('navigate');
    },
    logout() {
      this.$store.dispatch('auth/logout');
    },
    toggleMenu() {
      this.$store.dispatch('chrome/toggleMenu');
    },
  },
  components: {
    MiniSearch,
  },
} as IView;
